import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api, ENDPOINTS } from '../services';

// Async thunks
export const fetchSpaces = createAsyncThunk('spaces/fetchSpaces', async ({ page = 1, limit = 10, name = '' }) => {
  const params = new URLSearchParams({ page, limit });
  if (name.trim()) params.append('name', name.trim());
  const response = await api.get(`${ENDPOINTS.SPACES}?${params}`);
  if (!response?.data?.data || typeof response.data.data !== 'object') {
    throw new Error('Invalid response format');
  }
  return response.data.data;
});

export const createSpace = createAsyncThunk('spaces/createSpace', async (spaceData) => {
  const response = await api.post(ENDPOINTS.SPACES, spaceData);
  return response.data;
});

export const updateSpace = createAsyncThunk('spaces/updateSpace', async ({ id, data }) => {
  const response = await api.put(ENDPOINTS.SPACE_BY_ID(id), data);
  return response.data;
});

export const deleteSpace = createAsyncThunk('spaces/deleteSpace', async (id) => {
  await api.delete(ENDPOINTS.SPACE_BY_ID(id));
  return id;
});

const spaceSlice = createSlice({
  name: 'spaces',
  initialState: {
    spaces: [],
    totalSpaces: 0,
    currentPage: 1,
    loading: false,
    error: null
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaces.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpaces.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        if (action.payload && typeof action.payload === 'object') {
          state.spaces = Array.isArray(action.payload.spaces) ? action.payload.spaces : [];
          state.totalSpaces = typeof action.payload.total === 'number' ? action.payload.total : 0;
        }
      })
      .addCase(fetchSpaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createSpace.pending, (state) => {
        state.error = null;
      })
      .addCase(createSpace.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(createSpace.rejected, (state, action) => {
        state.error =
          typeof action.payload === 'string'
            ? action.payload
            : action.error?.message || 'Failed to create space';
      })
      .addCase(updateSpace.pending, (state) => {
        state.error = null;
      })
      .addCase(updateSpace.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(updateSpace.rejected, (state, action) => {
        state.error =
          typeof action.payload === 'string'
            ? action.payload
            : action.error?.message || 'Failed to update space';
      })
      .addCase(deleteSpace.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteSpace.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(deleteSpace.rejected, (state, action) => {
        state.error =
          typeof action.payload === 'string'
            ? action.payload
            : action.error?.message || 'Failed to delete space';
      });
  }
});

export const { setCurrentPage } = spaceSlice.actions;
export default spaceSlice.reducer;